import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { Assignment as AssignmentIcon } from '@mui/icons-material';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon = <AssignmentIcon sx={{ fontSize: 64, color: 'text.secondary' }} />,
  title,
  description,
  action
}) => {
  return (
    <Paper 
      sx={{ 
        p: 6, 
        textAlign: 'center', 
        borderRadius: 3,
        backgroundColor: 'background.default'
      }}
    >
      <Box sx={{ mb: 3 }}>
        {icon}
      </Box>
      
      <Typography variant="h6" fontWeight={600} sx={{ mb: 1 }}>
        {title}
      </Typography>
      
      {description && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {description}
        </Typography>
      )}
      
      {action && (
        <Button
          variant="contained"
          color="primary"
          onClick={action.onClick}
          sx={{ borderRadius: 2 }}
        >
          {action.label}
        </Button>
      )}
    </Paper>
  );
};

export default EmptyState;
